import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking, false = unauthenticated, object = authenticated
    const [user, setUser] = useState(null);

    const loadMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        loadMe();
    }, [loadMe]);

    const login = async (email, password, remember) => {
        const { data } = await api.post("/auth/login", { email, password, remember_me: remember });
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        setUser(false);
    };

    const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

    return (
        <AuthContext.Provider value={{ user, login, register, logout, updateUser, reload: loadMe, refresh: loadMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
